import type { Resource } from '../../';
export const product_tiles_quickView_button_text: Resource = {"default":"+ Quick Shop"};
